"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TGPageLabelWrapper_1 = __importDefault(require("./TGPageLabelWrapper"));
const Charts_1 = require("../Common/Charts");
// @ts-ignore
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const core_1 = require("@nivo/core");
const lodash_1 = require("lodash");
// TODO: [S5-3487] Strong typing for props.
const ChartFieldMap = {
    bar: Charts_1.TGBarChart,
    line: Charts_1.TGLineChart,
    pie: Charts_1.TGPieChart,
    scatterPlot: Charts_1.TGScatterPlotChart,
};
const TGPageChartField = props => {
    const { value, height, required, label, info, chartType, chartOptions, translateFunction = text => text } = props;
    const chartTheme = (0, core_1.usePartialTheme)((0, lodash_1.merge)({}, DEFAULT_THEME, value === null || value === void 0 ? void 0 : value.theme));
    // TODO: [S5-3741] Consolidate context/recoil hooks here, and add properties to `common` props. Should we add a callback for merging props with sample data/default props?
    const containerHeight = (0, react_1.useMemo)(() => Number(height) || 400, [height]);
    const ChartElement = (0, react_1.useMemo)(() => ChartFieldMap[chartType], [chartType]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!label && react_1.default.createElement(TGPageLabelWrapper_1.default, { required: required, readOnly: true, label: label, info: info, oneLine: false, translateFunction: translateFunction }),
        react_1.default.createElement("div", { style: { height: containerHeight } }, (!!ChartElement && (!!(value === null || value === void 0 ? void 0 : value.data) || !!(value === null || value === void 0 ? void 0 : value.showSampleData))) ? (react_1.default.createElement(ChartElement, Object.assign({}, chartOptions, value, { theme: chartTheme }))) : (
        // TODO: [S5-3487] User-friendly indication of failed data load.
        react_1.default.createElement(CircularProgress_1.default, { color: "primary", size: 64 })))));
};
const DEFAULT_THEME = {
    background: '#FFFFFF',
    text: {
        fontFamily: 'Roboto',
    },
};
exports.default = TGPageChartField;
//# sourceMappingURL=TGPageChartField.js.map